import {
  addToListenLater,
  removeFromListenLater,
  useUserDataStore,
} from '../global-state/user-data';
import { Episode } from '../models/podcasts';
import { trackAddToListenLaterClick } from '../utils/plausible-events';
import { Icon } from './icon';

export function ListenLaterButton({ episode }: { episode: Episode }) {
  const listenLaterEpisodeIds = useUserDataStore((s) => s.listenLaterEpisodeIds);

  return !listenLaterEpisodeIds.includes(episode.id) ? (
    <button
      onClick={() => {
        addToListenLater(episode);
        trackAddToListenLaterClick(episode);
      }}
      title="Add to listen later"
    >
      <Icon sprite="play-later" class="h-[26px] w-[26px] text-gray-400" />
    </button>
  ) : (
    <button
      onClick={() => removeFromListenLater(episode)}
      title="Remove from listen later"
    >
      <Icon sprite="play-later" class="h-[26px] w-[26px] text-icon-blue" />
    </button>
  );
}
